import { inject, observer } from 'mobx-react';
import React from 'react';
import { Page } from 'components';
import { AuthStore, RoutingStore } from '../stores';


export interface IVerifyAccountProps {
  authStore?:    AuthStore,
  routingStore?: RoutingStore,
}


/**
 * Used to verify a newly created user account.
 * 
 * @type any
 */
export const VerifyAccount = inject('authStore', 'routingStore')(observer((props: IVerifyAccountProps) => {
  const { authStore, routingStore } = props;

  return (
    <Page 
      sidebar = {undefined}
      topbar  = {undefined}
    >
      
    </Page>
  );
}));